import ApplicationAdapter from "./application";

export default class PrivateNetworkSegmentAdapter extends ApplicationAdapter {
  urlForCreateRecord() {
    return `${this.apiBaseUri}/privatenetwork/createsegment`;
  }

  urlForUpdateRecord(id) {
    return `${this.apiBaseUri}/privatenetwork/editsegment?id=${id}`;
  }

  urlForDeleteRecord(id) {
    return `${this.apiBaseUri}/privatenetwork/deletesegment?id=${id}`;
  }
}
